// generateLotWithIdQueryOptions.ts
export const generateLotWithIdQueryOptions = (
    lotId: string
): {
    variables: {
        lot_id: string
    }
} => ({
    variables: {
        lot_id: lotId.toUpperCase()
    }
})
